import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MccGovernmentIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccGovernmentIcon(props: MccGovernmentIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MccGovernmentIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.53469 14.4099C6.68229 14.496 6.75608 14.539 6.86023 14.5614C6.94106 14.5787 7.05898 14.5787 7.13981 14.5614C7.24396 14.539 7.31775 14.496 7.46535 14.4099C8.76405 13.6522 12.3334 11.2723 12.3334 7.99996V5.46663C12.3334 4.7507 12.3334 4.39274 12.223 4.13863C12.1108 3.88036 11.9991 3.74297 11.7691 3.58057C11.5427 3.42078 11.0991 3.32851 10.2118 3.14398C9.23389 2.94059 8.48287 2.57332 7.79627 2.04218C7.46703 1.78748 7.3024 1.66012 7.17358 1.62539C7.03765 1.58874 6.96239 1.58874 6.82646 1.62539C6.69764 1.66012 6.53301 1.78748 6.20377 2.04218C5.51717 2.57332 4.76615 2.94059 3.78822 3.14398C2.90094 3.32851 2.45729 3.42078 2.23098 3.58057C2.00097 3.74297 1.88921 3.88036 1.77705 4.13863C1.66669 4.39274 1.66669 4.7507 1.66669 5.46663V7.99996C1.66669 11.2723 5.23599 13.6522 6.53469 14.4099Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
